import { useCallback, useEffect } from "react";

function readTraceSnapshot(imageUrl, mediaEl, imgEl) {
  if (!mediaEl) return null;
  const mediaStyle = getComputedStyle(mediaEl);
  const imgStyle = imgEl ? getComputedStyle(imgEl) : null;
  const mr = mediaEl.getBoundingClientRect();
  const ir = imgEl ? imgEl.getBoundingClientRect() : null;
  const resolvedFromDom =
    imgEl && imgEl.currentSrc && imgEl.currentSrc.trim() !== ""
      ? imgEl.currentSrc
      : null;
  return {
    resolvedImageUrl:
      resolvedFromDom ?? (imageUrl != null ? String(imageUrl) : null),
    container: {
      width: Math.round(mr.width),
      height: Math.round(mr.height),
      aspectRatio: mediaStyle.aspectRatio || null,
    },
    imgRendered: imgEl
      ? {
          width: Math.round(ir.width),
          height: Math.round(ir.height),
        }
      : null,
    imgNatural: imgEl
      ? {
          width: imgEl.naturalWidth,
          height: imgEl.naturalHeight,
        }
      : null,
    objectFit: imgStyle?.objectFit ?? null,
    objectPosition: imgStyle?.objectPosition ?? null,
  };
}

/**
 * DEV-only layout instrumentation for Organized Tour hero images.
 */
export function useOrgTourHeroImageLayoutTrace({ imageUrl, mediaRef, imgRef }) {
  const enabled =
    typeof import.meta !== "undefined" && Boolean(import.meta.env?.DEV);

  const logLayout = useCallback(() => {
    if (!enabled) return;
    const media = mediaRef?.current;
    const img = imgRef?.current;
    const snapshot = readTraceSnapshot(imageUrl, media, img || null);
    if (snapshot) {
      console.log("[ORG_TOUR_HERO_IMAGE_LAYOUT_TRACE]", snapshot);
    }
  }, [enabled, imageUrl, mediaRef, imgRef]);

  useEffect(() => {
    if (!enabled) return;
    logLayout();
    const media = mediaRef?.current;
    if (!media) return;
    const ro = new ResizeObserver(() => {
      logLayout();
    });
    ro.observe(media);
    window.addEventListener("resize", logLayout);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", logLayout);
    };
  }, [enabled, imageUrl, logLayout, mediaRef]);

  const onHeroImageLoad = useCallback(() => {
    logLayout();
  }, [logLayout]);

  return { onHeroImageLoad, logLayout };
}
